/** Web client ID from Google Cloud Console (OAuth 2.0 Client IDs → Web application). */
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

export const isGoogleAuthConfigured = (): boolean => Boolean(GOOGLE_CLIENT_ID.trim());
